import { render, staticRenderFns } from "./E404.vue?vue&type=template&id=064fe960&"
import script from "./E404.vue?vue&type=script&lang=ts&"
export * from "./E404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports